import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISessionState } from '../../interfaces/state.interfaces';
import { ISession, SessionStage } from '../../interfaces/session.interface';

const initialState: ISessionState = {
    sessions: [],
    currentlyWorkingSession: null,
};

const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        SetSessions(state, action: PayloadAction<ISession[]>) {
            state.sessions = action.payload;
        },
        SetCurrentlyWorkingSession(state, action: PayloadAction<ISession | null>) {
            state.currentlyWorkingSession = action.payload;
        },
        UpdateSession(state, action: PayloadAction<ISession>) {
            const sessionIndex = state.sessions.findIndex(
                (session) => session.sessionKey === action.payload.sessionKey,
            );
            if (sessionIndex !== -1) {
                state.sessions[sessionIndex] = action.payload;
            }
        },
        UpdateSessionStage(
            state,
            action: PayloadAction<{ sessionKey: string; stage: SessionStage }>,
        ) {
            const sessionIndex = state.sessions.findIndex(
                (session) => session.sessionKey === action.payload.sessionKey,
            );
            if (sessionIndex !== -1) {
                state.sessions[sessionIndex].stage = action.payload.stage;
            }
        },
        RemoveSession(state, action: PayloadAction<string>) {
            state.sessions = state.sessions.filter(
                (session) => session.sessionKey !== action.payload,
            );
        },
        AddSession(state, action: PayloadAction<ISession>) {
            state.sessions = [action.payload, ...state.sessions];
        },
        SetSessionInitialState(state) {
            state.sessions = [];
            state.currentlyWorkingSession = null;
        },
    },
});

export const {
    SetSessions,
    SetCurrentlyWorkingSession,
    UpdateSession,
    UpdateSessionStage,
    RemoveSession,
    AddSession,
    SetSessionInitialState,
} = sessionSlice.actions;

export const sessionReducer = sessionSlice.reducer;
